import { del, get, post, put } from './api.service';

const base_url = 'subscriptions/v1';

export const getPlans = () => {
    return get(`${base_url}/plans`);
}
